function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;
function isNFTTuple(slips, i) {
  if (!slips || i + 2 >= slips.length) {
    return false;
  }
  var a = slips[i];
  var b = slips[i + 1];
  var c = slips[i + 2];
  return (a === null || a === void 0 ? void 0 : a.type) === SlipType.Bound && (c === null || c === void 0 ? void 0 : c.type) === SlipType.Bound && ((b === null || b === void 0 ? void 0 : b.type) === SlipType.Normal || (b === null || b === void 0 ? void 0 : b.type) === SlipType.ATR);
}
function collectNftTuples() {
  var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tuples = [];
  for (var i = 0; i + 2 < slips.length; i++) {
    if (!isNFTTuple(slips, i)) {
      continue;
    }
    var custody = slips[i + 1];
    tuples.push({
      slips: [slips[i], slips[i + 1], slips[i + 2]],
      custody_public_key: (custody === null || custody === void 0 ? void 0 : custody.publicKey) || ''
    });
    i += 2;
  }
  return tuples;
}

/** NFT triples created in transaction outputs. */
function returnCreatedNftTuples(tx) {
  return collectNftTuples((tx === null || tx === void 0 ? void 0 : tx.to) || []);
}

/** NFT triples consumed from transaction inputs. */
function returnSpentNftTuples(tx) {
  return collectNftTuples((tx === null || tx === void 0 ? void 0 : tx.from) || []);
}
function buildBuyerOrStoreScript(buyer_publickey, store_publickey) {
  return {
    op: 'CHECKMULTISIG',
    m: 1,
    publickeys: [buyer_publickey, store_publickey],
    msg: 'tx.from.p2sh.utxoset_key'
  };
}
function createListingScript(app) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    seller_publickey = _ref.seller_publickey,
    store_publickey = _ref.store_publickey;
  var script = buildBuyerOrStoreScript(seller_publickey, store_publickey);
  var hash = app.core.scripting.hash(script);
  var address = app.core.scripting.address(script);
  return {
    access_script: JSON.stringify(script),
    access_hash: hash,
    p2sh_address: address
  };
}
function createPurchaseScript(app) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    buyer_publickey = _ref2.buyer_publickey,
    store_publickey = _ref2.store_publickey;
  return createListingScript(app, {
    seller_publickey: buyer_publickey,
    store_publickey: store_publickey
  });
}
function parseAccessScript(access_script) {
  if (!access_script) {
    return null;
  }
  if (_typeof(access_script) === 'object') {
    return access_script;
  }
  try {
    return JSON.parse(access_script);
  } catch (err) {
    return null;
  }
}
function executeListingScript(_x, _x2, _x3) {
  return _executeListingScript.apply(this, arguments);
}
function _executeListingScript() {
  _executeListingScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, access_script, publickey) {
    var _app$core;
    var script, publickeys, msg, signature, _app$wallet, privatekey, executable, result, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          script = parseAccessScript(access_script);
          if (!(!script || String(script.op || '').toUpperCase() !== 'CHECKMULTISIG')) {
            _context.n = 1;
            break;
          }
          return _context.a(2, false);
        case 1:
          publickeys = Array.isArray(script.publickeys) ? script.publickeys : [];
          if (!(!publickey || !publickeys.includes(publickey))) {
            _context.n = 2;
            break;
          }
          return _context.a(2, false);
        case 2:
          msg = script.msg;
          if (msg) {
            _context.n = 3;
            break;
          }
          return _context.a(2, false);
        case 3:
          if (!(typeof msg === 'string' && msg.startsWith('tx.'))) {
            _context.n = 4;
            break;
          }
          return _context.a(2, true);
        case 4:
          if (app !== null && app !== void 0 && (_app$core = app.core) !== null && _app$core !== void 0 && (_app$core = _app$core.scripting) !== null && _app$core !== void 0 && _app$core.evaluate) {
            _context.n = 5;
            break;
          }
          return _context.a(2, false);
        case 5:
          signature = '';
          _context.p = 6;
          if (!(typeof ((_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.signMessage) === 'function')) {
            _context.n = 8;
            break;
          }
          _context.n = 7;
          return app.wallet.signMessage(msg);
        case 7:
          signature = _context.v;
          _context.n = 10;
          break;
        case 8:
          _context.n = 9;
          return app.wallet.getPrivateKey();
        case 9:
          privatekey = _context.v;
          signature = app.crypto.signMessage(msg, privatekey);
        case 10:
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t = _context.v;
          return _context.a(2, false);
        case 12:
          executable = JSON.parse(JSON.stringify(script));
          executable.witness = {
            signatures: [signature]
          };
          _context.n = 13;
          return app.core.scripting.evaluate(executable);
        case 13:
          result = _context.v;
          return _context.a(2, result === 1);
      }
    }, _callee, null, [[6, 11]]);
  }));
  return _executeListingScript.apply(this, arguments);
}
function signAccessScriptWitness(_x4, _x5, _x6) {
  return _signAccessScriptWitness.apply(this, arguments);
}
function _signAccessScriptWitness() {
  _signAccessScriptWitness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, access_script, message) {
    var _app$wallet2;
    var options,
      script,
      signature,
      privatekey,
      executable,
      executable_string,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
          script = parseAccessScript(access_script);
          if (!(!script || !message)) {
            _context2.n = 1;
            break;
          }
          throw new Error('access script and message are required for P2SH witness');
        case 1:
          signature = '';
          if (!(typeof ((_app$wallet2 = app.wallet) === null || _app$wallet2 === void 0 ? void 0 : _app$wallet2.signMessage) === 'function')) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return app.wallet.signMessage(message);
        case 2:
          signature = _context2.v;
          _context2.n = 5;
          break;
        case 3:
          _context2.n = 4;
          return app.wallet.getPrivateKey();
        case 4:
          privatekey = _context2.v;
          signature = app.crypto.signMessage(message, privatekey);
        case 5:
          executable = JSON.parse(JSON.stringify(script));
          executable.witness = {
            signatures: [signature]
          };
          executable_string = JSON.stringify(executable);
          return _context2.a(2, executable_string);
      }
    }, _callee2);
  }));
  return _signAccessScriptWitness.apply(this, arguments);
}
module.exports = {
  isNFTTuple: isNFTTuple,
  buildBuyerOrStoreScript: buildBuyerOrStoreScript,
  createListingScript: createListingScript,
  createPurchaseScript: createPurchaseScript,
  parseAccessScript: parseAccessScript,
  returnCreatedNftTuples: returnCreatedNftTuples,
  returnSpentNftTuples: returnSpentNftTuples,
  executeListingScript: executeListingScript,
  signAccessScriptWitness: signAccessScriptWitness
};